import { metadata, SVOD_RAIL_TVOD } from "lacinetek-common/src/metadata"

import { BlockTitle } from "components/subscription/block-title"
import { SliderRailProduct } from "components/subscription/rail-products"

export const Tvod = ({ block }) => {
	const category = block.children.items.find(category => metadata(category, SVOD_RAIL_TVOD) === "Oui")

	if (!category) {
		return null
	}

	return (
		<section className="tvod-color">
			<BlockTitle block={category} rail />
			<SliderRailProduct productIds={category.products.items} isOverlay />
		</section>
	)
}
